// @flow

export const TRACKING_EVENTS = {
  PAGE_VIEWED: 'page_viewed',
  // 상품 상세 URL 도달 (productId 없이 발송 가능, GA4 미발송 / 내부 진단용)
  PRODUCT_DETAIL_PAGE_VIEWED: 'product_detail_page_viewed',
  // 상품 API 로드 성공 (productId 포함, GA4 미발송 / 내부 진단용)
  PRODUCT_DETAIL_LOADED: 'product_detail_loaded',
  PRODUCT_VIEWED: 'product_viewed',
  PRODUCT_LIST_VIEWED: 'product_list_viewed',
  PRODUCT_SELECTED: 'product_selected',
  PRODUCT_CART_ADDED: 'product_cart_added',
  PRODUCT_CART_REMOVED: 'product_cart_removed',
  CART_VIEWED: 'cart_viewed',
  CHECKOUT_STARTED: 'checkout_started',
  SHIPPING_INFO_ADDED: 'shipping_info_added',
  PAYMENT_INFO_ADDED: 'payment_info_added',
  PURCHASE_COMPLETED: 'purchase_completed',
  PRODUCT_WISHLIST_ADDED: 'product_wishlist_added',
  SEARCH_PERFORMED: 'search_performed',
  CHAT_WIDGET_OPENED: 'chat_widget_opened',
};



// WEBPACK FOOTER //
// ./src/lib/tracking/events.js